import AlertListContainer from '../containers/AlertListContainer'
import Button from './fv-ui/Button'
import classNames from 'classnames'
import I18n from 'i18n'
import Modal, { ModalBody, ModalFooter, ModalHeader } from './fv-ui/Modal'
import PropTypes from 'prop-types'
import React from 'react'

const JoinLiveModal = ({
  location,
  open,
  onClose,
  onJoin,
  onSelectLocation
}) => (
  <div className="viewing-location-modal">
    {open && <AlertListContainer scope="joinModal" clearOnUnmount={true} />}
    <Modal open={open} onClose={onClose}>
      <ModalHeader>Select a viewing location</ModalHeader>
      <ModalBody unstyled={true}>
        <div
          className={classNames('location-toggle', {
            'fv-active': location === 'remote'
          })}
          onClick={() => onSelectLocation('remote')}
        >
          {I18n.t('Remote')}
        </div>
        <div
          className={classNames('location-toggle', {
            'fv-active': location === 'backroom'
          })}
          onClick={() => onSelectLocation('backroom')}
        >
          {I18n.t('Backroom')}
        </div>
      </ModalBody>
      <ModalFooter unstyled={true}>
        <Button
          disabled={!location}
          kinds={['link', 'block']}
          className="join-button"
          onClick={onJoin}
        >
          Join
        </Button>
      </ModalFooter>
    </Modal>
  </div>
)

JoinLiveModal.propTypes = {
  location: PropTypes.string,
  onClose: PropTypes.func,
  onJoin: PropTypes.func,
  onSelectLocation: PropTypes.func,
  open: PropTypes.bool
}

export default JoinLiveModal



// WEBPACK FOOTER //
// ../src/components/JoinLiveModal.js